import CuentasContablesService from "common/services/CuentasContablesService"
import EmpresaService from "common/services/EmpresaService"
import notification from "common/utils/notification"
import {
  fetchUsuarioEmpresaActiva,
  setEmpresaActivaDigitosCuentasContables,
} from "features/User/redux/slices/userSlice"
import { useDispatch } from "hooks/useDispatch"
import i18next from "i18next"
import { useCallback, useEffect, useState } from "react"

const empresaService = new EmpresaService()

const useCuentasContablesConfiguracion = ({
  initialNumeroDeCifras,
  initialPorDefectoClientes,
  initialPorDefectoProveedores,
  initialPorDefectoVentas,
  initialPorDefectoCompras,
  initialPorDefectoImpuestosVentas,
  initialPorDefectoImpuestosCompras,
  initialPorDefectoRetencionesVentas,
  initialPorDefectoRetencionesCompras,
  initialPorDefectoPrestamoConcedido,
  initialPorDefectoPrestamoRecibido,
  initialPorDefectoPrestamoInteresConcedido,
  initialPorDefectoPrestamoInteresRecibido,
  initialPorDefectoPrestamoComisionAperturaConcedido,
  initialPorDefectoPrestamoComisionEstudioConcedido,
  initialPorDefectoPrestamoComisionDisposicionConcedido,
  initialPorDefectoPrestamoComisionCorretajeConcedido,
  initialPorDefectoPrestamoComisionOtrasConcedido,
  initialPorDefectoPrestamoComisionAperturaRecibido,
  initialPorDefectoPrestamoComisionEstudioRecibido,
  initialPorDefectoPrestamoComisionDisposicionRecibido,
  initialPorDefectoPrestamoComisionCorretajeRecibido,
  initialPorDefectoPrestamoComisionOtrasRecibido,
  initialPorDefectoTicketReembolso,
}: $TSMigrationFixMe) => {
  const dispatch = useDispatch()

  const [savingChanges, setSavingChanges] = useState(false)
  const [haveChangesToSave, setHaveChangesToSave] = useState(false)

  const [newNumeroDeCifras, setNewNumeroDeCifras] = useState(null)
  const [newPorDefectoClientes, setNewPorDefectoClientes] = useState(null)
  const [newPorDefectoProveedores, setNewPorDefectoProveedores] = useState(null)
  const [newPorDefectoVentas, setNewPorDefectoVentas] = useState(null)
  const [newPorDefectoCompras, setNewPorDefectoCompras] = useState(null)
  const [newPorDefectoPrestamoConcedido, setNewPorDefectoPrestamoConcedido] =
    useState(null)
  const [newPorDefectoPrestamoRecibido, setNewPorDefectoPrestamoRecibido] =
    useState(null)

  // IMPUESTOS
  const [newPorDefectoImpuestosVentas, setNewPorDefectoImpuestosVentas] =
    useState(null)
  const [newPorDefectoImpuestosCompras, setNewPorDefectoImpuestosCompras] =
    useState(null)
  // RETENCIONES
  const [newPorDefectoRetencionesVentas, setNewPorDefectoRetencionesVentas] =
    useState(null)
  const [newPorDefectoRetencionesCompras, setNewPorDefectoRetencionesCompras] =
    useState(null)

  // PRESTAMOS
  // - CONCEDIDO
  const [
    newPorDefectoPrestamoInteresConcedido,
    setNewPorDefectoPrestamoInteresConcedido,
  ] = useState(null)
  const [
    newPorDefectoPrestamoInteresRecibido,
    setNewPorDefectoPrestamoInteresRecibido,
  ] = useState(null)
  const [
    newPorDefectoPrestamoComisionAperturaConcedido,
    setNewPorDefectoPrestamoComisionAperturaConcedido,
  ] = useState(null)
  const [
    newPorDefectoPrestamoComisionEstudioConcedido,
    setNewPorDefectoPrestamoComisionEstudioConcedido,
  ] = useState(null)
  const [
    newPorDefectoPrestamoComisionDisposicionConcedido,
    setNewPorDefectoPrestamoComisionDisposicionConcedido,
  ] = useState(null)
  const [
    newPorDefectoPrestamoComisionCorretajeConcedido,
    setNewPorDefectoPrestamoComisionCorretajeConcedido,
  ] = useState(null)
  const [
    newPorDefectoPrestamoComisionOtrasConcedido,
    setNewPorDefectoPrestamoComisionOtrasConcedido,
  ] = useState(null)

  const [
    newPorDefectoPrestamoComisionAperturaRecibido,
    setNewPorDefectoPrestamoComisionAperturaRecibido,
  ] = useState(null)
  const [
    newPorDefectoPrestamoComisionEstudioRecibido,
    setNewPorDefectoPrestamoComisionEstudioRecibido,
  ] = useState(null)
  const [
    newPorDefectoPrestamoComisionDisposicionRecibido,
    setNewPorDefectoPrestamoComisionDisposicionRecibido,
  ] = useState(null)
  const [
    newPorDefectoPrestamoComisionCorretajeRecibido,
    setNewPorDefectoPrestamoComisionCorretajeRecibido,
  ] = useState(null)
  const [
    newPorDefectoPrestamoComisionOtrasRecibido,
    setNewPorDefectoPrestamoComisionOtrasRecibido,
  ] = useState(null)
  const [newPorDefectoTicketReembolso, setNewPorDefectoTicketReembolso] =
    useState(null)

  const handleSetData = useCallback(
    (
      initialValue: $TSMigrationFixMe,
      newValue: $TSMigrationFixMe,
      setFunction: $TSMigrationFixMe
    ) => {
      if (initialValue === newValue) {
        return setFunction(null)
      }

      setFunction(newValue)
    },
    []
  )

  const handleSetNumeroDeCifras = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(initialNumeroDeCifras, newValue, setNewNumeroDeCifras)
    },
    [handleSetData, initialNumeroDeCifras]
  )

  const handleSetPorDefectoClientes = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoClientes,
        newValue.value,
        setNewPorDefectoClientes
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleSetData, initialPorDefectoClientes]
  )

  const handleSetPorDefectoProveedores = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoProveedores,
        newValue.value,
        setNewPorDefectoProveedores
      )
    },
    [handleSetData, initialPorDefectoProveedores]
  )

  const handleSetPorDefectoVentas = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoVentas,
        newValue.value,
        setNewPorDefectoVentas
      )
    },
    [handleSetData, initialPorDefectoVentas]
  )

  const handleSetPorDefectoCompras = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoCompras,
        newValue.value,
        setNewPorDefectoCompras
      )
    },
    [handleSetData, initialPorDefectoCompras]
  )

  // IMPUESTOS
  const handleSetPorDefectoImpuestosVentas = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoImpuestosVentas,
        newValue.value,
        setNewPorDefectoImpuestosVentas
      )
    },
    [handleSetData, initialPorDefectoImpuestosVentas]
  )

  const handleSetPorDefectoImpuestosCompras = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoImpuestosCompras,
        newValue.value,
        setNewPorDefectoImpuestosCompras
      )
    },
    [handleSetData, initialPorDefectoImpuestosCompras]
  )

  // RETENCIONES
  const handleSetPorDefectoRetencionesVentas = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoRetencionesVentas,
        newValue.value,
        setNewPorDefectoRetencionesVentas
      )
    },
    [handleSetData, initialPorDefectoRetencionesVentas]
  )

  const handleSetPorDefectoRetencionesCompras = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoRetencionesCompras,
        newValue.value,
        setNewPorDefectoRetencionesCompras
      )
    },
    [handleSetData, initialPorDefectoRetencionesCompras]
  )

  // PRESTAMO
  const handleSetPorDefectoPrestamoConcedido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoConcedido,
        newValue,
        setNewPorDefectoPrestamoConcedido
      )
    },
    [handleSetData, initialPorDefectoPrestamoConcedido]
  )

  const handleSetPorDefectoInteresesPrestamoConcedido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoInteresConcedido,
        newValue,
        setNewPorDefectoPrestamoInteresConcedido
      )
    },
    [handleSetData, initialPorDefectoPrestamoInteresConcedido]
  )

  const handleSetPorDefectoInteresesPrestamoRecibido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoInteresRecibido,
        newValue,
        setNewPorDefectoPrestamoInteresRecibido
      )
    },
    [handleSetData, initialPorDefectoPrestamoInteresRecibido]
  )

  const handleSetPorDefectoPrestamoComAperturaConcedido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoComisionAperturaConcedido,
        newValue,
        setNewPorDefectoPrestamoComisionAperturaConcedido
      )
    },
    [handleSetData, initialPorDefectoPrestamoComisionAperturaConcedido]
  )

  const handleSetPorDefectoPrestamoComEstudioConcedido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoComisionEstudioConcedido,
        newValue,
        setNewPorDefectoPrestamoComisionEstudioConcedido
      )
    },
    [handleSetData, initialPorDefectoPrestamoComisionEstudioConcedido]
  )

  const handleSetPorDefectoPrestamoComDisposicionConcedido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoComisionDisposicionConcedido,
        newValue,
        setNewPorDefectoPrestamoComisionDisposicionConcedido
      )
    },
    [handleSetData, initialPorDefectoPrestamoComisionDisposicionConcedido]
  )

  const handleSetPorDefectoPrestamoComCorretajeConcedido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoComisionCorretajeConcedido,
        newValue,
        setNewPorDefectoPrestamoComisionCorretajeConcedido
      )
    },
    [handleSetData, initialPorDefectoPrestamoComisionCorretajeConcedido]
  )

  const handleSetPorDefectoPrestamoComOtrasConcedido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoComisionOtrasConcedido,
        newValue,
        setNewPorDefectoPrestamoComisionOtrasConcedido
      )
    },
    [handleSetData, initialPorDefectoPrestamoComisionOtrasConcedido]
  )

  const handleSetPorDefectoPrestamoRecibido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoRecibido,
        newValue,
        setNewPorDefectoPrestamoRecibido
      )
    },
    [handleSetData, initialPorDefectoPrestamoRecibido]
  )

  const handleSetPorDefectoPrestamoComAperturaRecibido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoComisionAperturaRecibido,
        newValue,
        setNewPorDefectoPrestamoComisionAperturaRecibido
      )
    },
    [handleSetData, initialPorDefectoPrestamoComisionAperturaRecibido]
  )

  const handleSetPorDefectoPrestamoComEstudioRecibido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoComisionEstudioRecibido,
        newValue,
        setNewPorDefectoPrestamoComisionEstudioRecibido
      )
    },
    [handleSetData, initialPorDefectoPrestamoComisionEstudioRecibido]
  )

  const handleSetPorDefectoPrestamoComDisposicionRecibido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoComisionDisposicionRecibido,
        newValue,
        setNewPorDefectoPrestamoComisionDisposicionRecibido
      )
    },
    [handleSetData, initialPorDefectoPrestamoComisionDisposicionRecibido]
  )

  const handleSetPorDefectoPrestamoComCorretajeRecibido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoComisionCorretajeRecibido,
        newValue,
        setNewPorDefectoPrestamoComisionCorretajeRecibido
      )
    },
    [handleSetData, initialPorDefectoPrestamoComisionCorretajeRecibido]
  )

  const handleSetPorDefectoPrestamoComOtrasRecibido = useCallback(
    (newValue: $TSMigrationFixMe) => {
      handleSetData(
        initialPorDefectoPrestamoComisionOtrasRecibido,
        newValue,
        setNewPorDefectoPrestamoComisionOtrasRecibido
      )
    },
    [handleSetData, initialPorDefectoPrestamoComisionOtrasRecibido]
  )

  const handleSetPorDefectoTicketReembolso = useCallback(
    (newValue?: string) => {
      handleSetData(
        initialPorDefectoTicketReembolso,
        newValue,
        setNewPorDefectoTicketReembolso
      )
    },
    [handleSetData, initialPorDefectoTicketReembolso]
  )

  const actualizarConfiguracion = useCallback(
    async (payload: $TSMigrationFixMe) => {
      try {
        setSavingChanges(true)

        if (newNumeroDeCifras) {
          await CuentasContablesService.cambiarNumerosDeCifrasDeLasCuentasContables(
            newNumeroDeCifras
          )

          dispatch(setEmpresaActivaDigitosCuentasContables(newNumeroDeCifras))
        }

        if (payload) {
          await empresaService.UpdateEmpresaCuentasContables(payload)
          dispatch(fetchUsuarioEmpresaActiva())
        }

        notification.success({
          body: `${i18next.t("notification.configCorrectSaved")}`,
        })
      } finally {
        setSavingChanges(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [dispatch, newNumeroDeCifras]
  )

  useEffect(() => {
    const haveNewValues =
      !!newPorDefectoCompras ||
      !!newPorDefectoVentas ||
      !!newPorDefectoProveedores ||
      !!newPorDefectoClientes ||
      !!newNumeroDeCifras

    setHaveChangesToSave(haveNewValues)
  }, [
    newNumeroDeCifras,
    newPorDefectoClientes,
    newPorDefectoCompras,
    newPorDefectoProveedores,
    newPorDefectoVentas,
  ])

  useEffect(() => {
    setNewPorDefectoClientes(null)
    setNewPorDefectoProveedores(null)
    setNewPorDefectoVentas(null)
    setNewPorDefectoCompras(null)
  }, [
    initialPorDefectoClientes,
    initialPorDefectoProveedores,
    initialPorDefectoVentas,
    initialPorDefectoCompras,
  ])

  return {
    savingChanges,
    haveChangesToSave,
    newNumeroDeCifras,
    newPorDefectoClientes,
    newPorDefectoProveedores,
    newPorDefectoVentas,
    newPorDefectoCompras,
    newPorDefectoImpuestosCompras,
    newPorDefectoImpuestosVentas,
    newPorDefectoRetencionesCompras,
    newPorDefectoRetencionesVentas,
    newPorDefectoPrestamoConcedido,
    newPorDefectoPrestamoRecibido,
    newPorDefectoPrestamoInteresConcedido,
    newPorDefectoPrestamoInteresRecibido,
    newPorDefectoPrestamoComisionAperturaConcedido,
    newPorDefectoPrestamoComisionEstudioConcedido,
    newPorDefectoPrestamoComisionDisposicionConcedido,
    newPorDefectoPrestamoComisionCorretajeConcedido,
    newPorDefectoPrestamoComisionOtrasConcedido,
    newPorDefectoPrestamoComisionAperturaRecibido,
    newPorDefectoPrestamoComisionEstudioRecibido,
    newPorDefectoPrestamoComisionDisposicionRecibido,
    newPorDefectoPrestamoComisionCorretajeRecibido,
    newPorDefectoPrestamoComisionOtrasRecibido,
    newPorDefectoTicketReembolso,
    handleSetNumeroDeCifras,
    handleSetPorDefectoClientes,
    handleSetPorDefectoProveedores,
    handleSetPorDefectoVentas,
    handleSetPorDefectoCompras,
    handleSetPorDefectoImpuestosVentas,
    handleSetPorDefectoImpuestosCompras,
    handleSetPorDefectoRetencionesVentas,
    handleSetPorDefectoRetencionesCompras,
    handleSetPorDefectoPrestamoConcedido,
    handleSetPorDefectoPrestamoRecibido,
    handleSetPorDefectoInteresesPrestamoConcedido,
    handleSetPorDefectoInteresesPrestamoRecibido,
    handleSetPorDefectoPrestamoComAperturaConcedido,
    handleSetPorDefectoPrestamoComEstudioConcedido,
    handleSetPorDefectoPrestamoComDisposicionConcedido,
    handleSetPorDefectoPrestamoComCorretajeConcedido,
    handleSetPorDefectoPrestamoComOtrasConcedido,
    handleSetPorDefectoPrestamoComAperturaRecibido,
    handleSetPorDefectoPrestamoComEstudioRecibido,
    handleSetPorDefectoPrestamoComDisposicionRecibido,
    handleSetPorDefectoPrestamoComCorretajeRecibido,
    handleSetPorDefectoPrestamoComOtrasRecibido,
    handleSetPorDefectoTicketReembolso,
    actualizarConfiguracion,
  }
}

export default useCuentasContablesConfiguracion
